import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AnimatedCol from "../../../components/AnimatedCol";
import imageDE from "../../../images/20231009_Zugpfahl Kunststoff_DE.png";
import imageEN from "../../../images/20231009_Zugpfahl Kunststoff_EN.png";
import imageES from "../../../images/20231009_Zugpfahl Kunststoff_ES.png";
import { berechneDurchmesserDesRohres } from "../../../services/berechnePileHead";
import { useGetTraggliedDatenQuery } from "../../../services/API/titanApi";
import { selectBerechneInnere } from "../../../store/slices/innereSlice";
import { selectTragglied } from "../../../store/slices/traggliedSlice";
import BestimmungDesUebergangsrohres from "./BestimmungDesUebergangsrohres/BestimmungDesUebergangsrohres";
import KopfplatteDicke from "./LageKopfplatteUndUbergangsrohr/KopfplatteDicke";
import KopfplatteKantenlaenge from "./LageKopfplatteUndUbergangsrohr/KopfplatteKantenlaenge";

export default function ZugHDPE() {
  const { t, i18n } = useTranslation("translation");

  const tragglied = useSelector(selectTragglied);
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied.title);
  const innereData = useSelector(selectBerechneInnere(traggliedDaten));

  const [durchmesserDesRohres, setDurchmesserDesRohres] = useState(0);

  useEffect(() => {
    let durchmesserDesRohres = berechneDurchmesserDesRohres(
      Number(traggliedDaten?.durchmesser),
      innereData?.Csol
    );
    setDurchmesserDesRohres(durchmesserDesRohres);
    // Depend on the primitive value, not on `innereData`: selectBerechneInnere
    // is created inline on every render, so `innereData` is a new object
    // reference each time. Listing it here re-ran the effect and its setState on
    // every render — an infinite loop that froze the page (same bug as
    // DruckHDPE).
  }, [innereData?.Csol, traggliedDaten]);

  return (
    <>
      <BestimmungDesUebergangsrohres
        durchmesserDesRohres={durchmesserDesRohres}
        wanddickeUebergangsrohr={Number(traggliedDaten?.uebergangsrohr?.hdpe_rohr?.wanddicke)}
        einbindelaengeBaugrund={Number(traggliedDaten?.uebergangsrohr?.min_lb_zug)}
        laenge={Number(traggliedDaten?.uebergangsrohr?.laenge_zug)}
      />

      <div className="row">
        <div className="col-md-12">
          <h3> {t("aeussre.positionHeadPlateTransitionTube")}</h3>
        </div>
      </div>
      <AnimatedCol>
        <KopfplatteKantenlaenge kantenlaenge={traggliedDaten?.kopfkonstruktion?.kantenlaenge} />
      </AnimatedCol>

      <AnimatedCol>
        <KopfplatteDicke dicke={traggliedDaten?.kopfkonstruktion?.dicke} />
      </AnimatedCol>
      <Row>
        <Col md={8}>
          <p>{t("aeussre.distanceHeadPlateTransitionTube_infotext")}</p>
        </Col>
        <Col md={8}>
          <hr />
        </Col>
      </Row>
      <br />

      <div className="row">
        <div className="col-md-4">{/* <p>{t("aeussre.permissionZ4")}</p> */}</div>
        <div className="col-md-4">
          <img
            src={
              i18n.language === "de-DE" ? imageDE : i18n.language === "es-ES" ? imageES : imageEN
            }
            style={{ width: "100%" }}
            alt=""
          />
        </div>
      </div>
    </>
  );
}
